export const RECORDS_TABLE_HEADINGS = ["Property ID", "Property Owner", "location", "Map Lat/Long", "Pending Dues", ""];
export const RECORDS_TABLE_DATA_KEYS = ["propertyId", "ownerName", "location", "centroid", "dues", "actions"];